module.exports = {};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_iterators.js
 ** module id = 583
 ** module chunks = 2
 **/